if (!customElements.get('wood-announcement')) {
  customElements.define(
    'wood-announcement',
    class WoodAnnouncement extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.toggle = this.querySelector('.wood-announcement__toggle');

        if (!this.toggle) return;

        this.toggle.addEventListener('click', () => this.setPaused(!this.classList.contains('is-paused')), {
          signal: this.controller.signal,
        });
        this.setPaused(false);
        this.setAttribute('data-ready', '');
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      setPaused(paused) {
        this.classList.toggle('is-paused', paused);
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
    }
  );
}
